import { Badge, Button, Dropdown, FilterIcon, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './CustomFilter.module.scss';

export type CustomFilterEntry = {
  typeId: string;
  label: string;
  options: SelectOptionType[];
  values: SelectOptionType[];
};

type CustomFilterProps = {
  entries: CustomFilterEntry[];
  onFilterChange: (entry: CustomFilterEntry) => void;
  className?: string | undefined;
};

export const CustomFilter = ({ entries, onFilterChange, className }: CustomFilterProps) => {
  const { t } = useTranslation();

  const count = entries.reduce((prev, curr) => {
    return prev + (curr.values && curr.values?.length > 0 ? 1 : 0);
  }, 0);

  function handleClear() {
    entries.forEach((entry) => {
      onFilterChange({
        ...entry,
        values: [],
      });
    });
  }

  return (
    <div className={classNames(styles['custom-filter'], className)}>
      <Dropdown
        trigger={
          <div className={styles.trigger}>
            <Button hierarchy='secondary' icon={<FilterIcon />}>
              {t('customFilter.title')}
            </Button>
            {count > 0 && <Badge className={styles.badge} vertical='top' content={count} />}
          </div>
        }
      >
        <div className={styles.content}>
          <div className={styles.headline}>{t('customFilter.filter')}</div>

          <div className={styles.entries}>
            {entries.map(({ typeId, label, options, values }, index) => {
              return (
                <div key={`${index}-${typeId}`} className={styles.entry}>
                  <Select
                    className={styles.select}
                    name={`select-${index}-${typeId}`}
                    options={options}
                    label={label}
                    placeholder={t('common.all')}
                    menuPosition='fixed'
                    isMulti
                    isSearchable
                    isClearable
                    value={values}
                    onChange={(selection) => {
                      onFilterChange({
                        typeId,
                        label,
                        options,
                        values: selection as SelectOptionType[],
                      });
                    }}
                  />
                </div>
              );
            })}
          </div>

          <div className={styles.footer}>
            <div className={styles.actions}>
              <Button hierarchy='ghost' onClick={handleClear}>
                {t('customFilter.clearAll')}
              </Button>
            </div>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};
